import SocialMediaPage from "./socialMediaPage";

export default SocialMediaPage